<template>
  <div class="page-scan-out">
    <div class="pg-breadcrumb">
      <div class="breadcrumb-item em">珠海倉庫</div>
      <div class="breadcrumb-item">掃描出庫</div>
    </div>

    <div class="card-block">
      <Spin fix class="pg-sub-loading" v-if="isSubmiting">
        <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
        <div class="loading-text">Loading</div>
      </Spin>

      <div class="pg-form-wrap">
        <Form :label-width="150">
          <Row>
            <Col span="11">
              <FormItem>
                <div slot="label" class="form-label">
                  <em class="red">* </em>
                  <span>出庫袋號</span>
                </div>
                <Input v-model="form.sack_number" :disabled="form.type === 1"/>
              </FormItem>
              <FormItem>
                <div slot="label" class="form-label">
                  <em class="red">* </em>
                  <span>快遞單號</span>
                </div>
                <Input v-model="form.odd_numbers" ref='order_return_id' @on-change="myChange"
                       @keyup.enter.native="onSubmit"></Input>
              </FormItem>
              <FormItem>
                <div slot="label" class="form-label">
                  <span>快件類型</span>
                </div>
                <RadioGroup v-model="form.type" @on-change="getPickByType">
                  <Radio :label="0" :checked="form.type==0">普通件</Radio>
                  <Radio :label="1" :checked="form.type==1">散件</Radio>
                </RadioGroup>
              </FormItem>
            </Col>

            <Col span="11" push="1">
              <FormItem>
                <div slot="label" class="form-label">
                  <em class="red">* </em>
                  <span>選擇取件地</span>
                </div>
                <div>
                  <Select placeholder="門店"
                          style="width: 48.5%; margin-right: 3%;"
                          label-in-value
                          v-model="shopSelected"
                          @on-change="handleShopSelectChange"
                          :disabled="form.type === 1"
                  >
                    <Option value="0">請選擇（門店）</Option>
                    <Option :value="item.ReceivingID" v-for="(item, index) in shopList" :key="item.ReceivingID">
                      ({{ item.cainiao_match }}) {{ item.ReceivingName }}
                    </Option>
                  </Select>
                  <Select placeholder="智能櫃"
                          style="width: 48.5%;"
                          label-in-value
                          v-model="boxSelected"
                          @on-change="handleBoxSelectChange"
                          :disabled="form.type === 1"
                  >
                    <Option value="0">請選擇（智能櫃）</Option>
                    <Option :value="item.ReceivingID" v-for="(item, index) in boxList" :key="item.ReceivingID">
                      ({{ item.cainiao_match }}) {{ item.ReceivingName }}
                    </Option>
                  </Select>
                </div>
              </FormItem>

              <FormItem>
                <div slot="label" class="form-label">
                  <span>已選取件地</span>
                </div>
                <!-- <Input v-model="form.pickedAddress.join(', ')" @keyup.delete.native="del" :disabled="form.type === 1"/> -->
                <div class="input-value">
                  <!-- {{form.pickedAddress.join(', ')}} -->
                  <span v-for="(m, n) in form.pickedAddress"
                        style="background: #eee;padding: 0 5px;margin: 0 5px;font-size: 18px;position: relative;">
                    {{ m.name }}
                    <img style="display: inline-block;width:18px;height: 18px;top: 2px;position: relative;"
                      src="../../../assets/images/del.png" @click="unSelect(m.id)"></img>
                  </span>
                </div>
              </FormItem>
            </Col>

            <Col span="23">
              <FormItem>
                <div slot="label" class="form-label">
                  <span class="red">錯誤單號</span>
                </div>
                <div class="error-no">
                  {{ form.errorNo | join }}
                </div>
              </FormItem>
            </Col>

            <Col span="24">
              <FormItem>
                <div class="pg-btn-wrap pg-form-btn">
                  <div class="pg-btn style1" style="margin-right: 20px" @click="handleSearch">袋號明細</div>
                  <div class="pg-btn style2" @click="handleCheckFrom">出庫</div>
                  <!-- <Button type="error" :loading="true" class="loading-btn">
                       <span>Loading...</span>
                   </Button>-->
                </div>
              </FormItem>
            </Col>
          </Row>
        </Form>
      </div>

      <Table size="small"
             border
             no-data-text="暫無數據"
             :columns="table.column"
             :data="table.data">
        <template slot-scope="{ row, index }" slot="action">
          <div class="pg-btn-wrap">
            <div class="pg-btn style1" @click="handleDelete(index)">移出</div>
          </div>
        </template>
      </Table>

      <div class="pg-pagger">
        <Row>
          <Col span="11" class="pagger-left">
            <div class="pagger-total">總共{{ totalCount }}條記錄</div>
          </Col>
          <Col span="13" class="pagger-right">
            <!-- v-if="totalCount > curPageSize" -->
            <div>
              <div class="pagger-sizer">
                <span>每頁</span>
                <Select v-model="curPageSize" size="small" placeholder="數量"
                        @on-change="handlePageSizeChange">
                  <Option :value="10">10</Option>
                  <Option :value="20">20</Option>
                  <Option :value="30">30</Option>
                  <Option :value="40">40</Option>
                  <Option :value="50">50</Option>
                </Select>
              </div>

              <div class="pagger-elevator">
                <span>跳轉</span>
                <Input size="small" v-model="pageInput" @on-keyup="handlePageInput"
                       @on-enter="handlePageEnter"/>
              </div>

              <Page size="small"
                    :current="pageIndex"
                    :page-size="curPageSize"
                    :total="totalCount"
                    @on-change="handlePageChange">
              </Page>
            </div>
          </Col>
        </Row>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pageIndex: 1,
      curPageSize: 10,
      totalCount: 1,
      pageInput: '',
      shopList: [],   //門店
      shopListAll: [],
      shopSelected: '0',
      boxList: [],    //智能櫃
      boxSelected: '0',
      picks: [],
      err_audio: "https://jyb-admin-backend.aoyunltd.com/audio/music-fail.mp3",
      suc_audio: "https://jyb-admin-backend.aoyunltd.com/audio/music-success.mp3",
      form: {
        sack_number: '',
        odd_numbers: '',
        arrive: [], //門店或智能櫃id
        arrive_type: '', //1是門店，2是智能櫃
        pickedAddress: [],
        errorNo: [],
        type: 0
      },
      isSubmiting: false,
      table: {
        column: [
          /* {
               type: 'selection',
               minWidth: 60,
               align: 'center',
           },*/
          // {
          //     title: '序號',
          //     key: 'id',
          //     align: 'center',
          //     minWidth: 70,
          //     //sortable: true
          // },
          // {
          //     title: '會員號',
          //     key: 'userId',
          //     align: 'center',
          //     minWidth: 100
          // },
          {
            title: '快遞單號',
            key: 'odd_numbers',
            align: 'center',
            minWidth: 130
          },
          {
            title: '袋號',
            key: 'sack_number',
            align: 'center',
            minWidth: 100
          },
          {
            title: '門店',
            key: 'store',
            align: 'center',
            minWidth: 100
          },
          {
            title: '客戶名稱',
            key: 'username',
            align: 'center',
            minWidth: 100
          },
          {
            title: '電話號碼',
            key: 'recipient_phone',
            align: 'center',
            minWidth: 100
          },
          {
            title: '出庫時間',
            key: 'out_time',
            align: 'center',
            minWidth: 120
          },
          {
            title: '操作',
            slot: 'action',
            align: 'center',
            minWidth: 100
          }
        ],
        data: []
      }
    };
  },
  mounted() {
    this.getPickAddress(1);
    this.getPickAddress(2);
  },
  methods: {
    unSelect(id) {
      for (let i = 0; i < this.form.pickedAddress.length; i++) {
        if (id == this.form.pickedAddress[i].id) {
          this.form.pickedAddress.splice(i, 1);
        }
      }
      for (let i = 0; i < this.form.arrive.length; i++) {
        if (id == this.form.arrive[i]) {
          this.form.arrive.splice(i, 1);
        }
      }
    },
    myChange() {
      if (this.form.type == 1) {
        this.form.sack_number = this.form.odd_numbers;
      }
    },
    onSubmit() {
      this.handleCheckFrom();
    },
    getPickByType() {
      if (this.form.type == 1) {
        this.form.sack_number = this.form.odd_numbers;
        this.shopSelected = '';
        this.boxSelected = '';
        this.form.pickedAddress = [];
      } else {
        this.form.sack_number = '';
      }
    },
    del() {
      this.form.pickedAddress.pop();
      this.form.arrive.pop();
    },
    //獲取取件地，type 1門店， 2是智能櫃
    getPickAddress(type) {
    	const userInfo = localStorage.getItem('jyb_logInfo') ? JSON.parse(localStorage.getItem('jyb_logInfo')) : {};
    	const company_id = userInfo.parent_id == 1?0:userInfo.parent_id;
      this.$Rq.requestAuth({
        url: this.$Api.pickAddress,
        method: 'get',
        data: {
          type: type,
          company_id: company_id
        }
      }).then((res) => {
        if (res.code == 0) {
          if (type == 1) {
            this.shopList = JSON.parse(JSON.stringify(res.data.data));
            this.shopListAll = JSON.parse(JSON.stringify(res.data.data));
          } else if (type == 2) {
            this.boxList = res.data.data;
          }
        }
      });
    },

    handleSearch() {
      let form = this.form;
      if (form.sack_number === '') {
        this.$Utils.showTipInfo('請輸入出庫袋號');
        return;
      }
      this.getOrderBySackNo();
    },

    //根據袋號獲取訂單列表
    getOrderBySackNo() {
      this.isSubmiting = true;
      let form = this.form;
      this.$Rq.requestAuth({
        url: this.$Api.orderScanOutSearch,
        method: 'get',
        data: {
          //status: 0,  //0待出库, 1已出库
          sack_number: form.sack_number,
          offset: (this.pageIndex - 1) * this.curPageSize,
          limit: this.curPageSize,
        }
      }).then((res) => {
        this.isSubmiting = false;
        if (res.code == 0) {
          let resData = res.data.data;
          let tempArr = [];
          for (let i = 0, len = resData.length; i < len; i++) {
            tempArr.push({
              id: resData[i].id,
              odd_numbers: resData[i].odd_numbers,
              recipient_phone: resData[i].recipient_phone,
              userId: resData[i].user_id ? resData[i].user_id : '',
              username: resData[i].recipient_contacts ? resData[i].recipient_contacts : '',
              store: resData[i].arrive_name == null ? '- - -' : resData[i].arrive_name,
              sack_number: resData[i].sack_number == null ? '- - -' : resData[i].sack_number,
              out_time: resData[i].out_time ? resData[i].out_time : '- - -'
            });
          }
          this.totalCount = res.data.count;
          this.table.data = tempArr.reverse();
        }
      }).catch((err) => {
        this.isSubmiting = false;
      });
    },

    //選擇門店
    handleShopSelectChange(e) {
      if (e) {
        if (e.value != 0) {
          this.form.arrive.push(e.value);
          let isExist = false;
          for (let i = 0; i < this.form.pickedAddress.length; i++) {
            if (e.label == this.form.pickedAddress[i].name) {
              isExist = true;
              break;
            }
          }
          if (!isExist) {
            this.form.pickedAddress.push({id: e.value, name: e.label});
          } else {
            this.$Utils.showTipInfo('已存在該地址');
          }
          this.shopSelected = '0';
        }
      }
    },

    //選擇智能櫃
    handleBoxSelectChange(e) {
      if (e) {
        if (e.value != 0) {
          this.form.arrive.push(e.value);
          let isExist = false;
          for (let i = 0; i < this.form.pickedAddress.length; i++) {
            if (e.label == this.form.pickedAddress[i].name) {
              isExist = true;
              break;
            }
          }
          if (!isExist) {
            this.form.pickedAddress.push({id: e.value, name: e.label});
          } else {
            this.$Utils.showTipInfo('已存在地址');
          }
          this.boxSelected = '0';
        }
      }
    },

    handleCheckFrom() {

      let form = this.form;
      if (form.sack_number === '' && form.type === 0) {
        this.$Utils.showTipInfo('請輸入出庫袋號');
        return;
      } else if (form.odd_numbers === '') {
        this.$Utils.showTipInfo('請輸入快遞單號');
        return;
      } else if (this.form.type == 0 && this.form.pickedAddress.length <= 0) {
        this.$Utils.showTipInfo('請選擇取件地');
        return;
      }

      this.handleSubmit();
      this.$refs.order_return_id.focus();
      this.form.odd_numbers = '';
    },

    handleSubmit() {
      let form = this.form;
      this.isSubmiting = true;

      this.$Rq.requestAuth({
        url: this.$Api.scanOut,
        method: 'post',
        data: {
          sack_number: form.sack_number,
          odd_numbers: form.odd_numbers,
          // arrive_type: form.arrive_type, //1是門店，2是智能櫃,
          arrive: form.arrive, //門店或智能櫃id
          type: form.type
        }
      }).then((res) => {
        this.isSubmiting = false;

        if (res.code == 0) {
          // 成功
          if (res.msg == "出庫成功!") {
            let audio = new Audio()
            audio.src = this.suc_audio
            audio.play();
            this.$Utils.showSuccess(res.msg);
          } else {
            let audio = new Audio()
            audio.src = this.err_audio
            audio.play();
            this.$Utils.showTipInfo(res.msg);
            this.form.odd_numbers = '';
          }


          this.form = {
            sack_number: form.sack_number,
            odd_numbers: '',
            arrive: form.arrive, //門店或智能櫃id
            arrive_type: '', //1是門店，2是智能櫃
            pickedAddress: form.pickedAddress,
            errorNo: form.errorNo,
            type: form.type
          };
          //this.shopSelected = '';
          //this.boxSelected = '';
          this.form.errorNo = [];

          this.getOrderBySackNo(this.form.sack_number);
        } else {
          // 失败
          this.form.odd_numbers = '';
          let audio = new Audio()
          audio.src = this.err_audio
          audio.play();
          this.$Utils.showTipInfo(res.msg);
          if (res.code == 40035) {
            let odd_numbers = res.data.odd_numbers;
            let errorNo = this.form.errorNo;
            let isExist = false;

            for (let i = 0; i < errorNo.length; i++) {
              if (errorNo[i] == odd_numbers) {
                isExist = true;
                break;
              }
            }

            !isExist && this.form.errorNo.push(odd_numbers);
          }

        }
      }).catch((err) => {
        this.isSubmiting = false;
        this.$Utils.showTipInfo('服務器異常');
      });
    },

    handleDelete(index) {
      this.$Modal.confirm({
        title: '提示',
        content: '確定移出嗎？',
        cancelText: '取消',
        okText: '確定',
        onOk: () => {
          let tableData = this.table.data;
          this.isSubmiting = true;

          this.$Rq.requestAuth({
            url: this.$Api.delSack,
            method: 'post',
            data: {
              id: tableData[index].id
            }
          }).then((res) => {
            this.isSubmiting = false;

            if (res.code == 0) {
              this.$Utils.showSuccess(res.msg);
              if (tableData.length <= 1 && this.pageIndex > 1) {
                this.pageIndex -= 1;
              }
              tableData.splice(index, 1);
              this.table.data = tableData;

            } else {
              this.$Utils.showTipInfo(res.msg);
            }
          }).catch((err) => {
            this.isSubmiting = false;
          });
        }
      });
    },
    handlePageSizeChange(value) {
      this.pageIndex = 1;
      this.getOrderBySackNo();
    },

    handlePageInput() {
      let value = ('' + this.pageInput).replace(/\D/g, '');
      let pageCount = Math.ceil(this.totalCount / this.curPageSize);
      if (value > pageCount) {
        value = pageCount;
      }
      this.pageInput = value;
    },
    handlePageEnter() {
      if (this.pageInput == '' || this.pageInput == this.pageIndex) return;
      if (this.pageInput == 0) {
        this.pageInput = 1;
      }
      this.pageInput = parseInt(this.pageInput);
      this.pageIndex = this.pageInput;
      this.getOrderBySackNo();
    },

    handlePageChange(value) {
      this.pageIndex = value;
      this.getOrderBySackNo();
    }
  },
  filters: {
    join(arr) {
      if (typeof arr == 'object') {
        return arr.join(', ');
      } else {
        return ''
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "ScanOut.scss";
</style>
